import GenericModulePage from '../../components/generic/GenericModulePage';
import { initializeModule } from '../../utils/configInit';
import { contractConfig } from './contractConfig';
import { createContractValidationSchema } from './contractValidation';

const { config: initializedConfig } = initializeModule(
  contractConfig,
  createContractValidationSchema,
);

const ContractPage = () => <GenericModulePage config={initializedConfig} />;

ContractPage.displayName = 'ContractPage';

export default ContractPage;
